import * as actionType from "../constants/featureAccess";

const initialState = {
  loading: false,
  loaded: false,
  planId: null,
  planName: "",
  planType: "",
  features: [],
  limits: {
    events: { limit: "-1", used: 0 },
    active_events: { limit: "-1", used: 0 },
    seats: { limit: "-1", used: 0 },
    calendars: { limit: "-1", used: 0 },
    round_robin: { limit: "0", used: 0 },
    staff_confirm: { limit: "0", used: 0 },
  },
  stripeStatus: null,
  trialEndsAt: null,
  trialEligible: false,
  smsAllowed: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.FEATURES_FETCH_START:
      return { ...state, loading: true };
    case actionType.FEATURES_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        planId: action.payload.plan_id,
        planName: action.payload.plan_name,
        planType: action.payload.plan_type || "",
        features: action.payload.features,
        limits: action.payload.limits || state.limits,
        stripeStatus: action.payload.stripe_status || null,
        trialEndsAt: action.payload.trial_ends_at || null,
        trialEligible: Boolean(action.payload.trial_eligible),
        smsAllowed: Boolean(action.payload.sms_allowed),
      };
    case actionType.FEATURES_FETCH_FAIL:
      return { ...state, loading: false };
    default:
      return state;
  }
};
